export const T = {
  en_GB: {
    droppedSectionTitle: "Not part of this follow-up",
    droppedSectionInfo:
      "These funds are part of the existing savings plan but match no product in the portfolio collection, so they cannot be advised here.",
    droppedNoIsin: "No ISIN",
  },
  nb_NO: {
    droppedSectionTitle: "Ikke en del av denne oppfølgingen",
    droppedSectionInfo:
      "Disse fondene er en del av den eksisterende spareavtalen, men samsvarer ikke med noe produkt i produktsamlingen, og kan derfor ikke rådgis her.",
    droppedNoIsin: "Uten ISIN",
  },
} as const;
